import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Close(props: Partial<SVGProps<any>>) {
  return (
 <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M0.437363 0.366211C0.925482 -0.121917 1.71776 -0.121854 2.20592 0.366211L10.9803 9.1416L19.7557 0.367188C20.2439 -0.120919 21.0352 -0.120933 21.5233 0.367188C22.0114 0.855327 22.0114 1.6466 21.5233 2.13477L12.7479 10.9092L21.5956 19.7568C22.0835 20.245 22.0836 21.0363 21.5956 21.5244C21.1075 22.0125 20.3161 22.0124 19.828 21.5244L10.9803 12.6768L2.13365 21.5254C1.64558 22.0134 0.854216 22.0132 0.366074 21.5254C-0.122047 21.0373 -0.121986 20.246 0.366074 19.7578L9.21275 10.9092L0.437363 2.13379C-0.0504059 1.64568 -0.0504709 0.854284 0.437363 0.366211Z" fill="#212021"/>
</svg>
  )
}